import { v4 as uuid } from "uuid"
import { Serializable } from "@/core/api/decorators/serializable_decorator"
import { PriceCutType } from "../constants/priceCutType"
import { IsNumber, Min } from "class-validator"

@Serializable
export class PriceCutModel {
  uid: string = uuid()
  @Min(0, {
    message: '$t(common:form.errors.greater_or_equal, {"count": 0 })',
    groups: ["create_cut"],
  })
  @IsNumber(
    { allowNaN: false, allowInfinity: false },
    {
      message: "common:form.errors.number",
      groups: ["create_cut"],
    },
  )
  amount: number = 0
  amountCutType: number = PriceCutType.Percentage

  constructor(data?: Partial<PriceCutModel>) {
    Object.assign(this, data)
  }
}
